// src/Components/Tournaments/TournamentTabs.jsx
import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./TournamentDetails.css"; // משתמשים באותו CSS של הטורנירים

const TournamentTabs = ({ tournaments, selectedId, onSelect }) => {
  const { user } = useAuth();
  const { slug } = useParams();
  const navigate = useNavigate();


  // סינון טורנירים לפי הצגת האתר או מנהל, ומיון לפי שנה יורדת
  const visibleTournaments = useMemo(() => {
    return tournaments
      .filter(t => user?.isAdmin || t.showOnSite)
      .sort((a, b) => new Date(b.year) - new Date(a.year));
  }, [tournaments, user]);

  if (!visibleTournaments.length) return <p className="no-tournaments">אין טורנירים להצגה</p>;

  return (
    <div className="tournament-tabs">
      <h3>טורנירים קודמים</h3>
      <div className="tabs-list">
        {user?.isAdmin && (
            <button
              className="btn add-btn"
              onClick={() => navigate(`/tournaments/${slug}/eilat/new-year`)}
            >
              ➕ שנה חדשה
            </button>
          )}
        {visibleTournaments.map(t => (
          <button
            key={t._id}
            className={`tournament-item ${selectedId === t._id ? "selected" : ""}`}
            onClick={() => onSelect(t._id)}
          >
            {t.year} – {t.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TournamentTabs;
